import axios from 'axios';
import {
	FETCH_APARTMENT_PENDING,
	FETCH_APARTMENT_FULFILLED,
	FETCH_APARTMENT_FAILED
} from '../constants/apartments.actions';
import { BASE_API_URL } from '../constants/urls';

export const fetchApartmentPending = () => {
	return {
		type: FETCH_APARTMENT_PENDING,
		payload: null
	};
};

export const fetchApartmentFulfilled = (apartment) => {
	return {
		type: FETCH_APARTMENT_FULFILLED,
		payload: {
			apartment
		}
	};
};

export const fetchApartmentFailed = (status) => {
	return {
		type: FETCH_APARTMENT_FAILED,
		payload: {
			status
		}
	};
};

export const fetchApartment = (id, type) => {
	return async function(dispatch, getState) {
		const { apartmentBank } = getState().apartmentReducer;

		// The reducer holds a memory bank of all previous fetched apartments
		// If we already have the apartment we're navigating to, there's no need to fetch it again
		if(apartmentBank[id] !== undefined) {
			dispatch(fetchApartmentFulfilled(apartmentBank[id]));
			return;
		}

		// Otherwise we fetch the apartment
		dispatch(fetchApartmentPending());

		const query = type ? `?type=${type}` : ``
		try {
			// TODO: Fetch newest apartments and not just the apartments
			const response = await axios(`${BASE_API_URL}/apartments/${id}${query}`);
			dispatch(fetchApartmentFulfilled(response.data));
		} catch(error) {
			dispatch(fetchApartmentFailed(error.response.status));
		}
	};
};
